<template>
  <div class="tast-list-box">
    <div class="task-list-header">
      <div class="search-box"></div>
      <div class="operation-box">
        <el-button type="primary" @click="addTaskClick">新增任务</el-button>
      </div>
    </div>
    <div class="task-list-content">
      <el-table
          :data="tableData"
          height="calc(100vh - 200px)"
          style="width: 100%"
      >
        <el-table-column prop="name" label="任务名称" min-width="120">
        </el-table-column>
        <el-table-column
            prop="channel"
            align="center"
            label="发送渠道"
            min-width="80"
        >
          <template slot-scope="scope">
            <div>
              {{ scope.row.channel | channel }}
            </div>
          </template>
        </el-table-column>
        <el-table-column
            min-width="80"
            prop="sendType"
            align="center"
            label="发送人群"
        >
          <template slot-scope="scope">
            <div>
              {{ scope.row.crowd | crodType }}
            </div>
          </template>
        </el-table-column>

        <el-table-column
            min-width="80"
            prop="sendNumber"
            align="center"
            label="发送人数/群数"
        >
          <template slot-scope="scope">
            <div>
              {{ scope.row | sendNumber }}
            </div>
          </template>
        </el-table-column>
        <el-table-column
            min-width="80"
            prop="creater"
            align="center"
            label="创建人"
        >
          <template slot-scope="scope">
            <div>
              <span v-if="scope.row.creatorInfo!==null">{{ scope.row.creatorInfo.realName }}</span>
              <span v-else>--</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="date" label="日期" align="center" width="100">
          <template slot-scope="scope">
            <div>
              {{ new Date(scope.row.createTime).Format("yyyy-MM-dd hh:mm:ss") }}
            </div>
          </template>
        </el-table-column>
        <el-table-column fixed="right" label="操作" align="center" width="200">
          <template slot-scope="scope">
            <div class="operation-button">
              <el-switch
                  v-model="scope.row.open"
                  active-color="#13ce66"
                  @click.native="taskIsOpen(scope.row.open,scope.row.id)"
                  disabled
              >
              </el-switch>
              <el-tooltip class="item" effect="dark" content="查看发送记录" placement="top">
                <el-button
                    @click="handleClick(scope.row)"
                    icon="el-icon-view"
                    size="small"
                    circle
                ></el-button>
              </el-tooltip>
              <el-tooltip class="item" effect="dark" content="编辑任务" placement="top">
                <el-button
                    type="primary"
                    icon="el-icon-edit"
                    size="small"
                    circle
                    @click="editTask(scope.row)"
                ></el-button>
              </el-tooltip>
              <el-tooltip class="item" effect="dark" content="删除任务" placement="top">
                <el-button
                    type="danger"
                    icon="el-icon-delete"
                    size="small"
                    circle
                    @click="deleteTask(scope.row.id)"
                ></el-button>
              </el-tooltip>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
          class="task-pagination"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="taskPage"
          :page-sizes="[10, 20, 30, 40]"
          :page-size="taskPageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="taskTotal"
      >
      </el-pagination>
    </div>
    <!-- 新增任务抽屉 -->
    <el-drawer
        :title="taskTitle"
        :visible.sync="taskDrawer"
        size="70%"
        direction="rtl"
    >
      <div class="drawer-container">
        <div class="drawer-form-content">
          <el-form :style="{ pointerEvents: notEditTask ? 'none' : 'auto' }">
            <el-form-item label="任务名称" label-width="120px">
              <el-input
                  v-model="taskName"
                  autocomplete="off"
                  placeholder="请输入任务名称"
              ></el-input>
            </el-form-item>
            <el-form-item label="发送渠道" label-width="120px">
              <div class="select-channel">
                <el-radio-group
                    v-model="channelType"
                    @change="channelValueChange"
                >
                  <el-radio-button label="WE_WORK">企业微信</el-radio-button>
                  <!-- <el-radio-button label="DING_TALK">钉钉</el-radio-button>-->
                </el-radio-group>
                <!-- <el-select v-model="selectedChannel" :placeholder="elSelectPlaceholder">
                                <el-option
                                v-for="item in channelList"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                                </el-option>
                            </el-select>  -->
              </div>
            </el-form-item>
            <el-form-item label="发送人群" label-width="120px">
              <el-radio-group
                  v-model="selectedGroupType"
                  @change="changeSendPeople"
              >
                <el-radio-button label="EMPLOYEE">员工</el-radio-button>
                <el-radio-button label="CUSTOMER">客户</el-radio-button>
                <el-radio-button label="CUSTOMER_GROUP">客户群</el-radio-button>
                <!-- <el-radio-button label="CUSTOMER_MOMENT" v-if="channelType == 'WE_WORK' ">客户朋友圈</el-radio-button>-->
              </el-radio-group>
              <div style="margin-top: 24px" v-if="selectedGroupType!=='EMPLOYEE'">
                <el-alert
                    title="同一个企业每个自然月内仅可针对一个客户/客户群发送4个消息,超出接收上限的客户将无法再收到群发消息"
                    type="warning"
                    :closable="false">
                </el-alert>
              </div>
            </el-form-item>
            <el-form-item label="发送类型" label-width="120px">
              <div
                  class="form-item-box"
                  v-show="selectedGroupType == 'EMPLOYEE'"
              >
                <el-select
                    v-model="sendingRule"
                    placeholder="请选择"
                    @change="changeSendType"
                >
                  <el-option
                      v-for="item in sendingRulesList"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                  >
                  </el-option>
                </el-select>
              </div>
              <div class="newCustomer" v-show="selectedGroupType==='EMPLOYEE'&&sendingRule==='NEW_EMPLOYEE'">
                <div class="alert-text">
                  需配置【员工变更自动更新】
                </div>
              </div>
              <div
                  class="form-item-box"
                  v-show="
                  selectedGroupType == 'CUSTOMER' ||
                  selectedGroupType == 'CUSTOMER_MOMENT'
                "
              >
                <el-select v-model="customerScopeName" placeholder="请选择">
                  <el-option
                      v-for="item in customerScopeList"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                  >
                  </el-option>
                </el-select>
                <el-button
                    v-if="customerScopeName == 'CONDITIONAL'"
                    type="primary"
                    style="margin-left: 10px"
                    @click="checkTags"
                >标签选择
                </el-button
                >
              </div>
              <div
                  class="form-item-box"
                  v-show="selectedGroupType == 'CUSTOMER_GROUP'"
              >
                <el-button
                    type="primary"
                    style="margin-left: 10px"
                    @click="openSelectCustomerQun"
                >{{ groupBtnName }}
                </el-button
                >
              </div>
              <div
                  class="bind-bot-self-tree-box"
                  style="margin-top: 20px"
                  v-show="
                  (selectedGroupType == 'CUSTOMER' ||
                    selectedGroupType == 'CUSTOMER_MOMENT') &&
                  customerScopeName === 'CONDITIONAL'
                "
              >
                <div @click.stop="setActiveTreeIndex" :class="['selected-box']">
                  <div class="tag-box">
                    <span class="placeholder" v-if="employeeConfigTag.length === 0"
                    >请点击选择发送范围</span
                    >
                    <el-tag
                        v-for="(tagCell, tagCellIndex) in employeeConfigTag"
                        :key="tagCellIndex"
                        size="mini"
                        @close="handleCloseOrganization(tagCellIndex,tagCell.id)"
                        closable
                    >{{ tagCell.name }}
                    </el-tag
                    >
                  </div>
                  <!-- <div class="handle-teg-box">
                                    <span v-show="activeTreeIndex == index" class="el-icon-arrow-up"></span>
                                    <span v-show="activeTreeIndex != index" class="el-icon-arrow-down"></span>
                                </div> -->

                </div>
              </div>

            </el-form-item>
            <el-form-item label=" "
                          label-width="120px"
                          v-show="(selectedGroupType==='CUSTOMER')&&customerScopeName==='CONDITIONAL'"
            >
              <div class="form-tag"
                >
                <el-tag
                    v-for="tag in showTagsList"
                    :key="tag.name"
                >
                  {{ tag.name }}
                </el-tag>
              </div>
            </el-form-item>
            <el-form-item label="发送范围" label-width="120px"
                          v-show="selectedGroupType==='EMPLOYEE' ">
              <div
                  class="bind-bot-self-tree-box"

              >
                <div
                    @click.stop="
                                                    setActiveTreeIndex
                                                "
                    :class="['selected-box']"
                >
                  <div class="tag-box">
                    <span class="placeholder" v-if="employeeConfigTag.length===0">请点击选择发送范围</span>
                    <el-tag
                        v-for="(
                                                            tagCell, tagCellIndex
                                                        ) in employeeConfigTag"
                        :key="tagCellIndex"
                        size="mini"
                        @close="
                                                            handleCloseOrganization(
                                                                tagCellIndex,
                                                                tagCell.id
                                                            )
                                                        "
                        closable
                    >{{ tagCell.name }}
                    </el-tag
                    >
                  </div>
                  <!-- <div class="handle-teg-box">
                      <span v-show="activeTreeIndex == index" class="el-icon-arrow-up"></span>
                      <span v-show="activeTreeIndex != index" class="el-icon-arrow-down"></span>
                  </div> -->

                </div>
              </div>
            </el-form-item>
            <el-form-item
                label-width="120"
                label=""
                v-show="sendingRule==='SPECIAL_DATE_FOR_NEW_EMPLOYEE'&&selectedGroupType==='EMPLOYEE'"
            >
              <div class="induction-days">
                <span>入职后</span>
                <el-input v-model="inductionDaysNumber" placeholder="请输入" type="number" min="1"
                          style="width: 100%"></el-input>
                <el-select v-model="inductionDaysType" placeholder="请选择">
                  <el-option
                      v-for="item in inductionDaysTypeList"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                  </el-option>
                </el-select>
                <span style="padding-left: 20px">的员工</span>
              </div>
            </el-form-item>
            <el-form-item :label="sendingRule=='SPECIAL_DATE_FOR_NEW_EMPLOYEE'&&selectedGroupType==='EMPLOYEE'?'发送规则':'发送时间'"
                          label-width="120px"
            >
              <div class="send-date one-row">
                <div v-show="(sendingRule==='GENERAL'&&selectedGroupType==='EMPLOYEE')||selectedGroupType==='CUSTOMER'||selectedGroupType==='CUSTOMER_GROUP'" class="sendTime">
                  <el-radio-group v-model="sendTimeType">
                    <el-radio label="NOW">立即发送</el-radio>
                    <el-radio label="TIMED">定时发送</el-radio>
                    <el-radio label="PERIODIC">周期发送</el-radio>
                  </el-radio-group>

                </div>
                <div v-show="sendingRule==='NEW_EMPLOYEE'">
                  <span style="color: #409eff">新员工入职后立即发送</span>
                </div>
                <div v-show="sendingRule==='BIRTHDAY'">
                  <span style="color: #409eff">过生日当天</span>
                </div>
                <div v-show="sendingRule==='SPECIAL_DATE_FOR_NEW_EMPLOYEE'">
                  <el-radio-group v-model="newCustomer" @change="specialDate">
                    <el-radio :label="0">当天发送</el-radio>
                    <el-radio :label="-1">之前发送</el-radio>
                    <el-radio :label="1">之后发送</el-radio>
                  </el-radio-group>

                </div>
                <!-- <el-select v-model="sendDateType" placeholder="请选择">
                     <el-option
                     v-for="item in sendDateTypeList"
                     :key="item.value"
                     :label="item.label"
                     :value="item.value">
                     </el-option>
                 </el-select>
                 &lt;!&ndash; 需要找能支持农历和节假日显示的组件 &ndash;&gt;
                 <el-date-picker
                     v-if="sendDateType == '0' "
                     v-model="form.sendTime"
                     type="datetime"
                     placeholder="选择日期时间"
                     align="right">
                 </el-date-picker>-->
              </div>
            </el-form-item>
            <el-form-item
                label=""
                v-show="sendingRule==='SPECIAL_DATE_FOR_NEW_EMPLOYEE'&&(newCustomer===-1||newCustomer===1)"
            >
              <div style="display: flex;justify-content: flex-start">
                <span v-show="newCustomer===-1">之前</span>
                <span v-show="newCustomer===1">之后</span>
                <el-input placeholder="请输入" style="width: 30%;margin: 0 10px" v-model="specialDay"
                          type="number"
                          min="1"></el-input>
                天
              </div>
            </el-form-item>
            <el-form-item
                label-width="120px"
                label="周期规则"
                v-if="
                ((sendingRule === 'GENERAL'&&selectedGroupType==='EMPLOYEE')
                 || selectedGroupType==='CUSTOMER' ||selectedGroupType==='CUSTOMER_GROUP')
                 &&sendTimeType === 'PERIODIC'
              "
            >
              <el-radio-group v-model="periodicRule">
                <el-radio
                    v-for="(periodic, index) in periodicRuleList"
                    :label="periodic.value"
                    :key="index"
                >{{ periodic.label }}
                </el-radio
                >
              </el-radio-group>
            </el-form-item>
            <el-form-item
                label-width="120px"
                label="选择重复"
                v-if="
                sendTimeType === 'PERIODIC' &&
                (periodicRule === 'WEEK' || periodicRule === 'MOUTH')
              "
            >
              <el-checkbox-group
                  v-model="setWeek"
                  @change="handleCheckedCitiesChange"
                  v-if="periodicRule === 'WEEK'"
              >
                <el-checkbox
                    v-for="(week, index) in weekList"
                    :label="week.value"
                    :value="week.value"
                    :key="index"
                >{{ week.label }}
                </el-checkbox
                >
              </el-checkbox-group>
              <el-radio-group
                  v-model="setMonthTime"
                  v-if="periodicRule === 'MOUTH'"
              >
                <el-radio :label="1">每月第一天</el-radio>
                <el-radio :label="-1">每月最后一天</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item
                label-width="120px"
                label="选择日期"
                v-show="

                sendTimeType === 'PERIODIC' &&
                periodicRule === 'YEAR'
              "
            >
              <el-radio-group
                  v-model="GregorianOrLunar"
                  style="margin-right: 20px"
              >
                <el-radio
                    v-for="(data, index) in datePickerList"
                    :label="data.value"
                    :key="index"
                >
                  {{ data.label }}
                </el-radio>
              </el-radio-group>
              <el-date-picker
                  v-model="dataPicker"
                  type="date"
                  placeholder="选择日期"
                  :picker-options="dateOption"
              >
              </el-date-picker>
            </el-form-item>
            <el-form-item
                label="选择时间"
                label-width="120px"
                v-if="
                (sendingRule!=='NEW_EMPLOYEE'&&selectedGroupType==='EMPLOYEE'&&sendTimeType !== 'NOW')||(sendTimeType !== 'NOW'&&selectedGroupType!=='EMPLOYEE')
              "
            >
              <div v-if="sendingRule !== 'SPECIAL_DATE_FOR_NEW_EMPLOYEE'&&sendingRule !== 'BIRTHDAY'">
                <el-time-picker
                    v-model="checkTime"
                    placeholder="任意时间点"
                    v-if="sendTimeType!=='TIMED'"
                >
                </el-time-picker>
                <el-date-picker
                    v-model="checkDateTime"
                    type="datetime"
                    v-if="sendTimeType==='TIMED'"
                    :picker-options="dateOption"
                    @change="dateHandle"
                    placeholder="选择日期时间">
                </el-date-picker>
              </div>
              <div v-if="sendingRule === 'SPECIAL_DATE_FOR_NEW_EMPLOYEE'||sendingRule === 'BIRTHDAY'">
                <el-time-picker
                    v-model="specialDateTime"
                    placeholder="任意时间点"
                >
                </el-time-picker>
              </div>


            </el-form-item>
            <el-form-item label="发送内容" label-width="120px">
              <div class="send-content-type"></div>
              <div class="welcome-content">
                <welcome-type
                    :welcome-config="welcomeConfig"
                    :selectedGroupType="selectedGroupType"
                    :source="fromSouce"
                ></welcome-type>
              </div>
            </el-form-item>
          </el-form>
        </div>
        <div class="drawer-preview">
          <!-- <div class="business-card-template-preview-content">
                            <div class="chatbot-box">
                                <div class="chatbot-title gray">
                                    <div class="chatbot-title-text">对话窗</div>
                                </div>
                                <div class="chatbot-content">
                                    <div class="message-box">
                                        <div class="chatbot-message">
                                            <p>{{SendContentTextarea}}</p>
                                        </div>
                                    </div>
                                    <div class="mini-program">
                                        <div class="mini-program-name">小程序名称</div>
                                        <div class="mini-program-title">{{miniProgramTitle}}</div>
                                        <div class="mini-program-img">
                                            <el-image fit="cover" src="https://cube.elemecdn.com/6/94/4d3ea53c084bad6931a56d5158a48jpeg.jpeg"></el-image>
                                        </div>
                                    </div>
                                    <div class="chatbot-card">
                                        <div class="chatbot-card-img">
                                            <el-image fit="cover" src="https://cube.elemecdn.com/6/94/4d3ea53c084bad6931a56d5158a48jpeg.jpeg"></el-image>
                                        </div>
                                        <div class="chatbot-card-title">{{chatbotTypeTitle}}</div>
                                        <div class="chatbot-card-desc">{{chatbotTypeDesc}}</div>
                                        <div class="chatbot-card-click">查看详情</div>
                                    </div>
                                    &lt;!&ndash; <div class="message-box-user">
                                        <div class="user-message">
                                            <p>单位</p>
                                        </div>
                                    </div> &ndash;&gt;
                                </div>

                            </div>
                        <span style="font-size:18px;text-align:center;margin-left:100px">群发消息预览</span>
                        </div>-->
          <dialogue
              :preview="priview"
              :welcome-config="welcomeConfig"
              :source="fromSouce"
          ></dialogue>
        </div>
        <div slot="footer" class="drawer-footer">
          <el-button @click="taskDrawer = false">取 消</el-button>
          <el-button type="primary" @click="addTask" v-if="!notEditTask"
          >确 定
          </el-button
          >
        </div>
      </div>
    </el-drawer>
    <!-- 选择素材 -->
    <el-dialog
        title="选择素材"
        :visible.sync="materialDialogVisible"
        :close-on-click-modal="false"
        width="60%"
        top="4vh"
    >
      <div>
        <Material ref="materialSelect" :source="fromSouce"></Material>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="materialDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="materialDialogVisible = false"
        >确 定</el-button
        >
      </span>
    </el-dialog>
    <!-- 选择客户群 -->
    <el-dialog
        title="按条件筛选客户群"
        :visible.sync="SelectCustomerQunDialogVisible"
        :close-on-click-modal="false"
        width="40%"
        class="screenQun"
    >
      <!--<Qun
          :groupChatList="groupChatList"
          @lookMoreQun="lookMoreQun"
          :cursor="cursor"
          ref="selectCustomerQun"
          :notEditTask="notEditTask"
      ></Qun>-->
      <div>
        <div class="dialog-title">
          <span>按群主选择</span>
        </div>
        <div class="screen-radio">
          <el-radio v-model="groupAdminType" label="ALL">企业全部成员</el-radio>
          <el-radio v-model="groupAdminType" label="DEPARTMENT">按部门选择成员</el-radio>
        </div>
        <div class="memberShow" v-if="groupAdminType==='DEPARTMENT'">
          <div
              class="bind-bot-self-tree-box"

          >
            <div
                @click.stop="
                                                    setActiveGroupIndex
                                                "
                :class="['selected-box']"
            >
              <div class="tag-box">
                <span class="placeholder" v-if="originAdminSelectedTags.length===0">请选择</span>
                <el-tag
                    v-for="(
                                                            tagCell, tagCellIndex
                                                        ) in originAdminSelectedTags"
                    :key="tagCellIndex"
                    size="mini"
                    @close="
                                                            handleCloseOrganizationGroup(
                                                                tagCellIndex,
                                                                tagCell.id
                                                            )
                                                        "
                    closable
                >{{ tagCell.name }}
                </el-tag
                >
              </div>
              <!-- <div class="handle-teg-box">
                  <span v-show="activeTreeIndex == index" class="el-icon-arrow-up"></span>
                  <span v-show="activeTreeIndex != index" class="el-icon-arrow-down"></span>
              </div> -->

            </div>
          </div>
        </div>

      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="SelectCustomerQunDialogVisible = false"
        >取 消</el-button
        >
        <el-button type="primary" @click="SelectCustomerQun">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 客户标签 -->
    <el-dialog
        title="选择客户标签"
        :visible.sync="cutomerTagDialogVisible"
        :close-on-click-modal="false"
        width="50%"
    >
      <Tag ref="tagSelection"></Tag>
      <span slot="footer" class="dialog-footer">
        <el-button @click="cacelTags">取 消</el-button>
        <el-button type="primary" @click="selectTags">确 定</el-button>
      </span>
    </el-dialog>

    <!--选择成员-->
    <el-dialog
        title="选择成员"
        :visible.sync="memberDialogTableVisible"
        :close-on-click-modal="false"
        width="600px"
        class="selectMember"
    >
      <div class="bind-bot-self-tree">
       <!-- <department-tree :data="memberList" @onNodeClick="onNodeClick" v-if="selectedGroupType==='EMPLOYEE'"></department-tree>-->
        <el-tree
            :data="memberList"
            node-key="id"
            :default-expand-all="defaultExpandAll"
            :props="defaultProps"
            :expand-on-click-node="false"
            ref="memberTree"

        >
                                                    <span
                                                        class="custom-tree-node"
                                                        slot-scope="{node,data,}"
                                                    >
                                                         <div
                                                             style="display: flex;justify-content: flex-start;align-items: center">
                                                            <span v-if="!data.isMember">
                                                                <i class="arsenal_icon arsenalsitemap1"
                                                                   style="font-size: 14px;padding-right: 4px;display: flex;align-items: center"></i>
                                                            </span>
                                                            <span v-if="data.isMember">
                                                                <i class="arsenal_icon arsenaluser1"
                                                                   style="font-size: 14px;padding-right: 4px;display: flex;align-items: center"></i>
                                                            </span>
                                                            <span>{{ node.label }}</span>
                                                        </div>
                                                        <span>
                                                            <el-checkbox
                                                                @change="
                                                                    changeCheckedOrg(
                                                                        node,
                                                                        data,
                                                                        openMember
                                                                    )
                                                                "
                                                                v-model="
                                                                    data.checked
                                                                "
                                                                :disabled="data.disabled"
                                                            ></el-checkbox>
                                                        </span>
                                                    </span>
        </el-tree>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="memberDialogTableVisible = false">取 消</el-button>
        <el-button type="primary" @click="confirmMember">确 定</el-button>
      </div>
    </el-dialog>
    <!--查看发送记录-->
    <el-drawer
        title="发送记录"
        :visible.sync="sendRecord"
        direction="rtl"
        size="50%"
    >
      <el-table
          :data="sendRecordList"
          height="calc(100vh - 100px)"
      >
        <el-table-column
            type="index"
            label="序号"
            width="120"
            align="center"
        >
          <template slot-scope="scope">
            <span>{{ sendRecordList.length - scope.$index }}</span>
          </template>
        </el-table-column>
        <el-table-column
            property="name"
            label="接收人姓名"
        >
          <template slot-scope="scope">
            <div v-if="scope.row.name">
              {{ scope.row.name }}
            </div>
            <div v-else>--</div>
          </template>
        </el-table-column>
        <el-table-column
            label="发送时间"
            width="200"
            align="center"
        >
          <template slot-scope="scope">
            <div v-if="scope.row.createTime">{{ new Date(scope.row.createTime).Format('yyyy-MM-dd hh:mm:ss') }}</div>
            <div v-else></div>
          </template>

        </el-table-column>
        <!--              <el-table-column
                          label="备注"
                          min-width="200"
                          align="center"
                      >
                        <template slot-scope="scope">
                          <div>&#45;&#45;</div>
                        </template>

                      </el-table-column>-->
      </el-table>
    </el-drawer>
    <el-drawer
        title="发送记录"
        :visible.sync="sendCustomerRecord"
        direction="rtl"
        size="50%"
    >


      <el-table
          :data="sendRecordCustomerList"
          height="calc(100vh - 100px)"
      >
        <el-table-column
            type="index"
            label="#"
            width="50">
        </el-table-column>
        <el-table-column

            label="客户名称"
            min-width="100"
            align="center"
        >
          <template slot-scope="scope">
            <div>
              {{ scope.row.customerName }}
            </div>
          </template>
        </el-table-column>
        <el-table-column
            property="type"
            label="任务类型"
            width="100"
            align="center"
        >
          <template slot-scope="scope">
            <div>
              {{ scope.row.type }}
            </div>
          </template>
        </el-table-column>
        <el-table-column

            label="员工"
            width="100"
            align="center"
        >
          <template slot-scope="scope">
            <div>
              {{ scope.row.memberName }}
            </div>
          </template>
        </el-table-column>
        <el-table-column

            label="发送结果"
            align="center"
            min-width="100"
        >
          <template slot-scope="scope">
            <div>
              {{ scope.row.sendResult }}
            </div>
          </template>
        </el-table-column>
        <el-table-column
            label="发送时间"
            width="100"
            align="center"
        >
          <template slot-scope="scope">
            <div v-if="scope.row.createTime">{{
                new Date(scope.row.createTime * 1000).Format('yyyy-MM-dd hh:mm:ss')
              }}
            </div>
            <div v-else>--</div>
          </template>

        </el-table-column>
      </el-table>
      <el-pagination
          v-if="taskDetail.crowd==='CUSTOMER'"
          @size-change="handleSizeChangeSend"
          @current-change="handleCurrentChangeSend"
          :current-page="customerSendPage"
          :page-sizes="[10, 20, 30, 40]"
          :page-size="customerSendSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="sendListTotal"
          style="position: absolute;bottom: 10px;right: 10px"
      >
      </el-pagination>
    </el-drawer>
    <el-drawer
        title="发送记录"
        :visible.sync="sendCustomerGroupRecord"
        direction="rtl"
        size="50%"
    >

      <el-table
          :data="sendRecordCustomerGroupList"
          height="calc(100vh - 100px)"
      >
        <el-table-column
            type="index"
            label="#"
            width="50">
        </el-table-column>
        <el-table-column
            property="groupName"
            label="客户群名称"
            min-width="100"
        >
          <template slot-scope="scope">
            <div>
              {{ scope.row.groupName }}
            </div>
          </template>
        </el-table-column>
        <el-table-column
            property="type"
            label="任务类型"
            width="100"
        >
          <template slot-scope="scope">
            <div>
              {{ scope.row.type }}
            </div>
          </template>
        </el-table-column>
        <el-table-column
            property="customerName"
            label="员工"
            width="100"
            align="center"
        >
          <template slot-scope="scope">
            <div>
              {{ scope.row.customerName }}
            </div>
          </template>
        </el-table-column>
        <el-table-column
            property="sendResult"
            label="发送结果"
            align="center"
            min-width="100"
        >
          <template slot-scope="scope">
            <div>
              {{ scope.row.sendResult }}
            </div>
          </template>
        </el-table-column>
        <el-table-column
            label="发送时间"
            width="100"
            align="center"
        >
          <template slot-scope="scope">
            <div v-if="scope.row.createTime">{{
                new Date(scope.row.createTime * 1000).Format('yyyy-MM-dd hh:mm:ss')
              }}
            </div>
            <div v-else></div>
          </template>

        </el-table-column>
      </el-table>
    </el-drawer>

  </div>
</template>

<script>
import Material from "./../../components/materialSelection";
import Tag from "./../../components/tagSelection";
import Qun from "./components/qunSelection";
import WelcomeType from "../leadsSource/compontent/welcomeType";
import Dialogue from "../leadsSource/compontent/dialogue";
import {formatTree} from "../../components/utils/formatTree";
import Calendar from "../../components/Calendar";
import {getChildren, showParent} from "@/assets/js/getChildrenLeng";
import DepartmentTree from "./components/DepartmentTree";

export default {
  components: {DepartmentTree, Calendar, Dialogue, WelcomeType, Material, Tag, Qun},
  data() {
    const generateData = (_) => {
      const data = [];
      const cities = ["上海", "北京", "广州", "深圳", "南京", "西安", "成都"];
      const pinyin = [
        "shanghai",
        "beijing",
        "guangzhou",
        "shenzhen",
        "nanjing",
        "xian",
        "chengdu",
      ];
      cities.forEach((city, index) => {
        data.push({
          label: city,
          key: index,
          pinyin: pinyin[index],
        });
      });
      return data;
    };
    return {
      tableData: [],
      switchValue: true,
      taskDrawer: false,
      deleteTaskDialogVisible: false,
      memberDialogTableVisible: false,
      memberQunDialogTableVisible: false,
      taskName: "",
      channelType: "WE_WORK",
      elSelectPlaceholder: "请选择应用类型",
      isSelectedChannelDisable: true,
      channelList: [
        {
          value: "0",
          label: "企微-果然SCRM",
        },
        {
          value: "1",
          label: "公众号-客户管理",
        },
      ],
      selectedChannel: "",
      selectedGroupType: "CUSTOMER",
      isGroupTypeDisable: true,
      sendingRulesList: [
        {
          value: "GENERAL",
          label: "通用消息",
        },
        {
          value: "NEW_EMPLOYEE",
          label: "新员工入职",
        },
        {
          value: "BIRTHDAY",
          label: "员工生日祝福",
        },
        {
          value: "SPECIAL_DATE_FOR_NEW_EMPLOYEE",
          label: "入职特殊日期",
        },
      ],
      sendingRule: "GENERAL",
      customerScopeList: [
        {
          value: "CONDITIONAL",
          label: "按条件筛选客户",
        },
        {
          value: "PUBLIC",
          label: "全部客户",
        },
      ],
      customerScopeName: "PUBLIC",
      inductionDaysNumber: 1,
      inductionDaysTypeList: [
        {
          value: "DAY",
          label: "天",
        },
        {
          value: "WEEK",
          label: "周",
        },
        {
          value: "MONTH",
          label: "月",
        },
        {
          value: "YEAR ",
          label: "年",
        },
      ],
      inductionDaysType: "DAY",
      sendDateTypeList: [
        {
          value: "0",
          label: "指定日期",
        },
        {
          value: "1",
          label: "立即发送",
        },
      ],
      sendDateType: "",
      SendContentTextarea: "",
      form: {
        props: {multiple: true},
        options: [],
      },
      materialDialogVisible: false,
      SelectCustomerQunDialogVisible: false,
      chatbotTypeTitle: "",
      chatbotTypeDesc: "",
      miniProgramTitle: "",
      miniProgramAppID: "",
      miniProgramPage: "",
      addChatbotDialogVisible: false,
      addMiniProgramDialogVisible: false,
      // 客户标签
      cutomerTagDialogVisible: false,
      // 穿梭框
      data: generateData(),
      value: [],
      filterMethod(query, item) {
        return item.pinyin.indexOf(query) > -1;
      },
      welcomeConfig: {
        attachments: [],
        text: {
          content: "",
        },
      },
      priview: "群发消息预览",
      fileList: [],
      sendTimeType: "NOW",
      checkTime: "",
      specialDateTime: "",
      checkDateTime: '',
      sendDays: "1",
      newCustomer: 0,
      showTagsList: [],
      memberList: [],
      treeLens: 0,
      orgTree: [],
      defaultExpandAll: false,
      defaultProps: {
        children: "children",
        label: "name",
      },
      userIds: [],
      keyValue: 0,
      activeTreeIndex: 0,
      userTags: [],
      employeeConfigUserIds: [],
      showTree: false,
      periodicRuleList: [
        {
          value: "DAY",
          label: "每天",
        },
        {
          value: "WEEK",
          label: "每周",
        },
        {
          value: "MOUTH",
          label: "每月",
        },
        {
          value: "YEAR",
          label: "每年",
        },
      ], //周期规则
      periodicRule: "DAY",
      weekList: [
        {
          value: 2,
          label: "周一",
        },
        {
          value: 3,
          label: "周二",
        },
        {
          value: 4,
          label: "周三",
        },
        {
          value: 5,
          label: "周四",
        },
        {
          value: 6,
          label: "周五",
        },
        {
          value: 7,
          label: "周六",
        },
        {
          value: 1,
          label: "周日",
        },
      ],
      setWeek: [2],
      setMonthTime: 1,
      dataPicker: "",
      dateOption: {
        disabledDate: (time) => {
          return time.getTime() < Date.now() - 1 * 24 * 3600 * 1000
        }
      },
      datePickerList: [
        {
          value: "CALENDAR",
          label: "公历",
        },
        {
          value: "LUNAR",
          label: "农历",
        },
      ],
      GregorianOrLunar: "CALENDAR",
      treeExpandData: [],
      taskPage: 1,
      taskPageSize: 10,
      taskTotal: 0,
      tagsList: [],
      selectTask: {},
      taskTitle: "新增群发任务",
      testUserIds: [],
      taskId: "",
      notEditTask: false,
      groupChatList: [],
      cursor: "",
      groupIds: [],
      sendRecord: false,
      sendCustomerGroupRecord: false,
      sendCustomerRecord: false,
      sendRecordList: [],
      sendRecordCustomerGroupList: [],
      sendRecordCustomerList: [],
      specialDay: 1,
      fromSouce: 'massSend',
      groupAdminType: 'ALL',
      originAdminSelectedIds: [],
      groupAdminIds: [],
      originAdminSelected: [],
      originAdminSelectedTags: [],
      openMember: '',
      groupBtnName: '按条件筛选客户群',
      taskDetail: {},
      employeeConfigTag: [],
      customerSendPage: 1,
      customerSendSize: 10,
      sendListTotal: 0,
      lookSendDetail: {},
      childrenLength:0
    };
  },

  methods: {
    onNodeClick(node){
      console.log(node)
      if (node.checked){
        this.userTags.push(node)
      }
      else {
        for (let i=0;i<this.userTags.length;i++){
          if (this.userTags[i].id===node.id){
            this.userTags.splice(i,1)
          }
        }
      }
      this.userTags=[...this.userTags]
      console.log(this.userTags)
    },
    confirmMember(){
      this.memberDialogTableVisible=false
    },
    reduceData(data){
      let obj = {};
      let peon = data.reduce((cur, next) => {
        obj[next.id] ? "" : obj[next.id] = true && cur.push(next);
        return cur;
      }, [])
      return peon
    },
    handleClick(value) {
      /* this.editTask(value);*/

      this.sendRecordList = []
      this.sendRecordCustomerGroupList = []
      this.sendRecordCustomerList = []
      this.taskDetail = value
      let recordList = []
      console.log(value)
      this.lookSendDetail = value
      let data = Object.assign({}, this.customerSendPage, {
        page: this.customerSendPage - 1
      })
      let url = ''
      if (value.crowd === 'CUSTOMER_GROUP') {
        url = '/scrm-api/group-send-message-task/send-record/employee-group/' + value.id
        this.sendCustomerGroupRecord = true
      } else if (value.crowd === 'EMPLOYEE') {
        url = '/scrm-api/group-send-message-task/send-record/employee/' + value.id
        this.sendRecord = true
      } else {
        url = '/scrm-api/group-send-message-task/send-record/custom/' + value.id + '?page=' + data.page + '&size=' + this.customerSendSize
        this.sendCustomerRecord = true
      }
      this.$http.get(url).then(res => {
        console.log('发送记录', res)
        if (value.sendType === 'CUSTOMER_GROUP') {
          let sendRecordList = JSON.parse(JSON.stringify(res.data))
          let customerGroup = []
          for (let i = 0; i < sendRecordList.length; i++) {
            if (sendRecordList[i].customerGroupConfig) {
              if (sendRecordList[i].customerGroupConfig.syncResultRecord) {
                if (sendRecordList[i].customerGroupConfig.syncResultRecord.resultResponses) {

                  for (let j = 0; j < sendRecordList[i].customerGroupConfig.syncResultRecord.resultResponses.length; j++) {

                    if (sendRecordList[i].customerGroupConfig.syncResultRecord.resultResponses[j].send_list && sendRecordList[i].customerGroupConfig.syncResultRecord.resultResponses[j].send_list.length > 0) {
                      for (let k = 0; k < sendRecordList[i].customerGroupConfig.syncResultRecord.resultResponses[j].send_list.length; k++) {
                        let userInfo = {
                          customerName: '',
                          createTime: '',
                          type: "客户群",
                          sendResult: '',
                          groupName: '',
                          index: ''
                        }
                        if (sendRecordList[i].customerGroupConfig.syncResultRecord.resultResponses[j].send_list[k].send_time) {
                          userInfo.createTime = sendRecordList[i].customerGroupConfig.syncResultRecord.resultResponses[j].send_list[k].send_time
                        }

                        if (sendRecordList[i].customerGroupConfig.syncResultRecord.resultResponses[j].send_list[k].status === 0) {
                          userInfo.sendResult = '未发送'
                        }
                        if (sendRecordList[i].customerGroupConfig.syncResultRecord.resultResponses[j].send_list[k].status === 1) {
                          userInfo.sendResult = '已发送'
                        }
                        if (sendRecordList[i].customerGroupConfig.syncResultRecord.resultResponses[j].send_list[k].status === 2) {
                          userInfo.sendResult = '因客户不是好友导致发送失败'
                        }
                        if (sendRecordList[i].customerGroupConfig.syncResultRecord.resultResponses[j].send_list[k].status === 3) {
                          userInfo.sendResult = '因客户已经收到其他群发消息导致发送失败'
                        }
                        console.log(sendRecordList[i].customerGroupConfig.syncResultRecord.resultResponses[j].send_list[k].chat_id)
                        if (sendRecordList[i].customerGroupConfig.groupInfos[sendRecordList[i].customerGroupConfig.syncResultRecord.resultResponses[j].send_list[k].chat_id]) {
                          userInfo.groupName = sendRecordList[i].customerGroupConfig.groupInfos[sendRecordList[i].customerGroupConfig.syncResultRecord.resultResponses[j].send_list[k].chat_id].name
                          console.log(sendRecordList[i].customerGroupConfig.groupInfos[sendRecordList[i].customerGroupConfig.syncResultRecord.resultResponses[j].send_list[k].chat_id])
                        }
                        if (sendRecordList[i].customerGroupConfig.userInfos[sendRecordList[i].customerGroupConfig.syncResultRecord.resultResponses[j].send_list[k].userid]) {
                          userInfo.customerName = sendRecordList[i].customerGroupConfig.userInfos[sendRecordList[i].customerGroupConfig.syncResultRecord.resultResponses[j].send_list[k].userid].name
                          console.log(sendRecordList[i].customerGroupConfig.userInfos[sendRecordList[i].customerGroupConfig.syncResultRecord.resultResponses[j].send_list[k].userid])
                        }
                        customerGroup.push(userInfo)
                      }

                    }

                  }

                }
              }
            }
          }
          this.sendRecordCustomerGroupList = customerGroup.reverse()
        } else if (value.crowd === 'EMPLOYEE') {
          let sendRecordList = JSON.parse(JSON.stringify(res.data))
          for (let i = 0; i < sendRecordList.length; i++) {
            if (sendRecordList[i].employeeConfig !== null) {
              if (sendRecordList[i].employeeConfig.userInfos !== null && sendRecordList[i].employeeConfig.userIds !== null) {

                for (let j = 0; j < sendRecordList[i].employeeConfig.userIds.length; j++) {
                  let userInfo = {
                    name: '',
                    createTime: ''
                  }

                  userInfo.createTime = sendRecordList[i].createTime
                  if (sendRecordList[i].employeeConfig.userInfos[sendRecordList[i].employeeConfig.userIds[j]]) {
                    userInfo.name = sendRecordList[i].employeeConfig.userInfos[sendRecordList[i].employeeConfig.userIds[j]].name
                  }else{
                     userInfo.name = sendRecordList[i].employeeConfig.requestParam.touser;
                  }

                  recordList.push(userInfo)
                }
              }
            }
          }
          console.log(recordList)
          this.sendRecordList = recordList.reverse()
        } else {

          let customerSendList = JSON.parse(JSON.stringify(res.data.content))
          let customerList = []
          this.sendListTotal = res.data.totalElements
          if (customerSendList) {
            for (let i = 0; i < customerSendList.length; i++) {
              let userInfo = {
                customerName: '',
                createTime: '',
                type: "客户",
                sendResult: '',
                memberName: '',
                index: ""
              }
              if (customerSendList[i].memberInfo) {
                userInfo.memberName = customerSendList[i].memberInfo.name
              }
              if (customerSendList[i].externalContact) {
                userInfo.customerName = customerSendList[i].externalContact.name
              }
              if (customerSendList[i].status === 0) {
                userInfo.sendResult = '未发送'
              }
              if (customerSendList[i].status === 1) {
                userInfo.sendResult = '已发送'
              }
              if (customerSendList[i].status === 2) {
                userInfo.sendResult = '因客户不是好友导致发送失败'
              }
              if (customerSendList[i].status === 3) {
                userInfo.sendResult = '因客户已经收到其他群发消息导致发送失败'
              }
              if (customerSendList[i].send_time) {
                userInfo.createTime = customerSendList[i].send_time
              }
              customerList.push(userInfo)
            }
          }
          this.sendRecordCustomerList = customerList.reverse()
        }


      })
      /*  this.notEditTask = true;*/
    },
    taskIsOpen(value, id) {
      console.log(value, id)
      let url = ''
      if (!value) {
        this.$confirm('是否开启任务?', '开启任务', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          url = '/scrm-api/group-send-message-task/open/' + id
          this.$http.put(url).then(res => {
            console.log(res)
            this.$message({
              message: '打开任务成功',
              duration: 2000,
              type: 'success'
            })
            this.getTask()
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消开启任务'
          });
        });

      } else {
        this.$confirm('是否关闭任务?', '关闭任务', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          url = '/scrm-api/group-send-message-task/close/' + id
          this.$http.put(url).then(res => {
            this.$message({
              message: '关闭任务成功',
              duration: 2000,
              type: 'success'
            })
            this.getTask()
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消关闭任务'
          });
        });

      }
    },
    editTask(value) {
      console.log('123Value', value);
      this.taskName = value.name;
      this.channelType = value.channel;
      this.selectedGroupType = value.crowd;

      this.welcomeConfig.attachments = JSON.parse(JSON.stringify(value.attachments));


      this.welcomeConfig.text = JSON.parse(JSON.stringify(value.text));
      this.testUserIds = [];
      this.userTags = [];
      this.employeeConfigTag=[]
      this.sendTimeType = "NOW";
      this.periodicRule = "DAY";
      this.checkTime = "";
      this.specialDateTime = ''
      this.newCustomer = 0
      this.inductionDaysNumber = 1
      this.checkDateTime = ""
      this.specialDay = 1
      this.inductionDaysType = 'DAY'
      this.setWeek = [2];
      this.showTagsList = [];
      this.groupIds = [];
      this.originAdminSelectedIds = []
      this.originAdminSelected = []
      this.groupAdminType = 'ALL'
      this.groupAdminIds = []
      this.taskTitle = "修改群发任务";
      this.selectTask = value;
      this.taskDrawer = true;
      this.taskId = value.id;
      this.notEditTask = false;
      this.showTree = false;
      this.groupBtnName = '按条件筛选客户群'
      this.initDefault(value.crowd, this.selectTask);
    },
    //切换发送类型初始化数据
    initDefault(type, value) {
      console.log('init default value', value)
      if (type === "CUSTOMER_GROUP") {
        if (value.weWorkCustomerGroupConfig !== null) {
          if (value.weWorkCustomerGroupConfig.sendTimeType !== null) {
            this.sendTimeType = value.weWorkCustomerGroupConfig.sendTimeType
          }
          if (value.weWorkCustomerGroupConfig.originAdminSelectedIds) {
            this.originAdminSelectedIds = value.weWorkCustomerGroupConfig.originAdminSelectedIds
            console.log('this.originAdminSelectedIds', this.originAdminSelectedIds)
            this.groupBtnName = '修改筛选条件下的客户群'
          }
          if (value.weWorkCustomerGroupConfig.groupAdminType) {
            this.groupAdminType = value.weWorkCustomerGroupConfig.groupAdminType
          }
          if (value.weWorkCustomerGroupConfig.groupAdminIds) {
            this.groupAdminIds = value.weWorkCustomerGroupConfig.groupAdminIds
          }

          this.groupIds = value.weWorkCustomerGroupConfig.groupIds;
          if (this.sendTimeType === 'TIMED') {
            if (value.weWorkCustomerGroupConfig.timed.date !== null) {
              this.checkDateTime = value.weWorkCustomerGroupConfig.timed.date
            }
          }
          if (value.weWorkCustomerGroupConfig.periodic&&value.weWorkCustomerGroupConfig.periodic.rule) {
            this.periodicRule = value.weWorkCustomerGroupConfig.periodic.rule
            if (value.weWorkCustomerGroupConfig.periodic.weekConfig !== null) {
              this.setWeek = value.weWorkCustomerGroupConfig.periodic.weekConfig.days
              this.checkTime = value.weWorkCustomerGroupConfig.periodic.weekConfig.time
            }
            if (value.weWorkCustomerGroupConfig.periodic.dayConfig !== null) {
              this.checkTime = value.weWorkCustomerGroupConfig.periodic.dayConfig.time
            }
            if (value.weWorkCustomerGroupConfig.periodic.monthConfig !== null) {
              this.checkTime = value.weWorkCustomerGroupConfig.periodic.monthConfig.time
              this.setMonthTime = value.weWorkCustomerGroupConfig.periodic.monthConfig.day
            }
            if (value.weWorkCustomerGroupConfig.periodic.yearConfig !== null) {
              this.checkTime = value.weWorkCustomerGroupConfig.periodic.yearConfig.time
              this.dataPicker = value.weWorkCustomerGroupConfig.periodic.yearConfig.date
              this.GregorianOrLunar = value.weWorkCustomerGroupConfig.periodic.yearConfig.type
            }
          }
          this.seachSelectGroupUserIds(this.memberList, value.weWorkCustomerGroupConfig.originAdminSelectedIds)

          this.originAdminSelected = this.reduceData(this.originAdminSelected)
          console.log('我是群成员', this.originAdminSelected)
        }
      }
      if (type === "CUSTOMER") {
        if (value.weWorkCustomerConfig !== null) {
          this.customerScopeName = value.weWorkCustomerConfig.to;
          let tagList = [];
          let userIds = [];
          value.weWorkCustomerConfig.tagIds.forEach((ids) => {
            this.tagsList.forEach((tag) => {
              tag.tags.forEach((tagItem) => {
                if (ids === tagItem.id) {
                  tagList.push(tagItem);
                }
              });
            });
          });
          console.debug('tag init', tagList);
          this.seachSelectUserIds(this.memberList, value.weWorkCustomerConfig.originSelectIds,'CUSTOMER')
          this.userTags = this.reduceData(this.employeeConfigTag)
          this.employeeConfigTag=this.userTags.filter(item=>item.isMember===true).map(member=>member)
          this.showTagsList = tagList
          if (value.weWorkCustomerConfig.sendTimeType) {
            this.sendTimeType = value.weWorkCustomerConfig.sendTimeType
          }
          if (this.sendTimeType === 'TIMED') {
            if (value.weWorkCustomerConfig.timed.date !== null) {
              this.checkDateTime = value.weWorkCustomerConfig.timed.date
            }
          }
          if (value.weWorkCustomerConfig.periodic&&value.weWorkCustomerGroupConfig.periodic.rule) {
            this.periodicRule = value.weWorkCustomerConfig.periodic.rule
            if (value.weWorkCustomerConfig.periodic.weekConfig !== null) {
              this.setWeek = value.weWorkCustomerConfig.periodic.weekConfig.days
              this.checkTime = value.weWorkCustomerConfig.periodic.weekConfig.time
            }
            if (value.weWorkCustomerConfig.periodic.dayConfig !== null) {
              this.checkTime = value.weWorkCustomerConfig.periodic.dayConfig.time
            }
            if (value.weWorkCustomerConfig.periodic.monthConfig !== null) {
              this.checkTime = value.weWorkCustomerConfig.periodic.monthConfig.time
              this.setMonthTime = value.weWorkCustomerConfig.periodic.monthConfig.day
            }
            if (value.weWorkCustomerConfig.periodic.yearConfig !== null) {
              this.checkTime = value.weWorkCustomerConfig.periodic.yearConfig.time
              this.dataPicker = value.weWorkCustomerConfig.periodic.yearConfig.date
              this.GregorianOrLunar = value.weWorkCustomerConfig.periodic.yearConfig.type
            }
          }
        }
      }
      if (type === 'EMPLOYEE') {
        if (value.weWorkEmployeeConfig !== null) {
          this.seachSelectUserIds(this.memberList, value.weWorkEmployeeConfig.originSelectIds,'EMPLOYEE')
          this.employeeConfigTag = this.reduceData(this.employeeConfigTag)
          this.userTags = this.reduceData(this.employeeConfigTag)
          if (value.weWorkEmployeeConfig.sendTimeType !== null) {
            this.sendTimeType = value.weWorkEmployeeConfig.sendTimeType
          }
          this.sendingRule = value.sendType;
          if (this.sendTimeType === 'TIMED') {
            if (value.weWorkEmployeeConfig.timed.date !== null) {
              this.checkDateTime = value.weWorkEmployeeConfig.timed.date
            }
          }
          if (value.sendType === 'BIRTHDAY') {
            if (value.weWorkEmployeeConfig.birthDayDateConfig !== null) {
              this.specialDateTime = value.weWorkEmployeeConfig.birthDayDateConfig.time
            }
          }
          console.log('value.sendType', value)
          if (value.sendType === 'SPECIAL_DATE_FOR_NEW_EMPLOYEE') {
            if (value.weWorkEmployeeConfig.newEmployeeSpecialDateConfig !== null) {
              if (value.weWorkEmployeeConfig.newEmployeeSpecialDateConfig.diff !== null) {
                if (value.weWorkEmployeeConfig.newEmployeeSpecialDateConfig.diff < 0) {
                  this.newCustomer = -1
                  this.specialDay = -(value.weWorkEmployeeConfig.newEmployeeSpecialDateConfig.diff)
                } else if (value.weWorkEmployeeConfig.newEmployeeSpecialDateConfig.diff > 0) {
                  this.newCustomer = 1
                  this.specialDay = value.weWorkEmployeeConfig.newEmployeeSpecialDateConfig.diff
                } else {
                  this.newCustomer = 0
                  this.specialDay = 1
                }
              }
              this.inductionDaysNumber = value.weWorkEmployeeConfig.newEmployeeSpecialDateConfig.duration.num
              this.inductionDaysType = value.weWorkEmployeeConfig.newEmployeeSpecialDateConfig.duration.timeUnit
              this.specialDateTime = value.weWorkEmployeeConfig.newEmployeeSpecialDateConfig.time
            }

          }
          if (value.weWorkEmployeeConfig.periodic&&value.weWorkEmployeeConfig.periodic.rule) {
            this.periodicRule = value.weWorkEmployeeConfig.periodic.rule
            if (value.weWorkEmployeeConfig.periodic.weekConfig !== null) {
              this.setWeek = value.weWorkEmployeeConfig.periodic.weekConfig.days
              this.checkTime = value.weWorkEmployeeConfig.periodic.weekConfig.time
            }
            if (value.weWorkEmployeeConfig.periodic.dayConfig !== null) {
              this.checkTime = value.weWorkEmployeeConfig.periodic.dayConfig.time
            }
            if (value.weWorkEmployeeConfig.periodic.monthConfig !== null) {
              this.checkTime = value.weWorkEmployeeConfig.periodic.monthConfig.time
              this.setMonthTime = value.weWorkEmployeeConfig.periodic.monthConfig.day
            }
            if (value.weWorkEmployeeConfig.periodic.yearConfig !== null) {
              this.checkTime = value.weWorkEmployeeConfig.periodic.yearConfig.time
              this.dataPicker = value.weWorkEmployeeConfig.periodic.yearConfig.date
              this.GregorianOrLunar = value.weWorkEmployeeConfig.periodic.yearConfig.type
            }
          }

        }

      }
    },
    /*遍历人员信息*/
    seachSelectUserIds(value, ids,type) {
      if (value !== null) {
        if (ids) {
          for (let i = 0; i < value.length; i++) {
            if (ids.indexOf(value[i].id) !== -1) {
              this.employeeConfigTag.push(value[i])
              this.seachSelectUserIds(value[i].children, ids,type)
            } else {
              this.seachSelectUserIds(value[i].children, ids,type)
            }
          }
        }

      } else
        return
    },
    seachSelectGroupUserIds(value, ids) {
      console.log(value, ids)
      if (value !== null) {
        for (let i = 0; i < value.length; i++) {
          if (ids.indexOf(value[i].id) !== -1) {
            this.originAdminSelected.push(value[i])
            this.seachSelectGroupUserIds(value[i].children, ids)
          } else {
            this.seachSelectGroupUserIds(value[i].children, ids)
          }
        }

      } else
        return
    },
    channelValueChange() {
      this.isSelectedChannelDisable = false;
      if (this.channelType == 'WE_WORK') {
        this.elSelectPlaceholder = '请选择企业微信应用';
      } else if (this.channelType == 'DING_TALK') {
        this.elSelectPlaceholder = '请选择钉钉应用';
      }
    },
    changeSelectedChannel() {
      this.isGroupTypeDisable = false;
    },
    handleRemove() {

    },
    handlePreview() {
    },
    addTaskClick() {
      this.notEditTask = false
      this.taskTitle = '新增群发任务'
      this.taskDrawer = true
      this.welcomeConfig.attachments = []
      this.channelType = 'WE_WORK'
      this.selectedGroupType = 'CUSTOMER'
      this.taskName = ''
      this.sendingRule = 'GENERAL'
      this.welcomeConfig.text = {
        content: ''
      }
      this.userTags = []
      this.employeeConfigTag=[]
      this.customerScopeName = 'PUBLIC'
      this.groupIds = []
      this.showTagsList = []
      this.setWeek = [2]
      this.checkTime = ''
      this.specialDateTim = ''
      this.checkDateTime = ""
      this.sendTimeType = 'NOW'
      this.periodicRule = 'DAY'
      this.testUserIds = []
      this.groupBtnName = '按条件筛选客户群'
    },
    dateHandle() {
      var startAt = new Date(this.checkDateTime) * 1000 / 1000;
      if (startAt < Date.now()) {
        this.checkDateTime = new Date();
      }
    },
    TimeHandle() {
      if (this.checkTime) {
        var startAt = new Date(this.checkTime) * 1000 / 1000;
        if (startAt < Date.now()) {
          this.checkTime = new Date();
        }
      }

    },
    //切换发送类型
    changeSendType(value) {
      console.log(value)
    },
    //新增任务
    addTask() {
      let originSelectIds = []
      let tags = []
      this.groupAdminIds = []
      this.originAdminSelectedIds = []
      let employeeIds = []
      let employeeSelectedConfigs = []
      let taskInfo = {
        attachments: this.welcomeConfig.attachments,
        channel: this.channelType,
        crowd: this.selectedGroupType,
        name: this.taskName,
        sendType: '',
        text: this.welcomeConfig.text
      }
      let timed = {}
      if (this.sendTimeType == 'TIMED') {
        timed.date = this.checkDateTime
      }
      if (this.originAdminSelected.length > 0) {
        this.originAdminSelected.forEach(item => {
          if (item.isMember === true) {
            this.groupAdminIds.push(item.id)
          }
          this.originAdminSelectedIds.push(item.id)
        })

      }
      console.log('groupAdminIds', this.groupAdminIds)
      console.log('originAdminSelectedIds', this.originAdminSelectedIds)
      if (this.selectedGroupType === 'EMPLOYEE') {
        taskInfo.sendType = this.sendingRule
        employeeSelectedConfigs = this.employeeConfigTag.length > 0? this.employeeConfigTag.map((member) =>{
          let info={
            type:member.isMember?'MEMBER':'DEPARTMENT',
            id: member.id
          }
          return info
        }):[]
        originSelectIds = this.employeeConfigTag.length>0?this.employeeConfigTag.map(item=>item.id):[]
        taskInfo.weWorkEmployeeConfig = {
          sendType: this.sendingRule,
          originSelectIds: originSelectIds,
          employeeSelectedConfigs: employeeSelectedConfigs,
          weWorkAgentId: "",
          version: 1,
          sendTimeType: this.sendTimeType,
          timed: timed,
          periodic: {}
        }
        if (this.sendingRule === 'BIRTHDAY') {
          taskInfo.weWorkEmployeeConfig.birthDayDateConfig = {
            time: this.specialDateTime
          }
        }
        if (this.sendingRule === 'SPECIAL_DATE_FOR_NEW_EMPLOYEE') {
          console.log(this.newCustomer * (this.specialDay))
          taskInfo.weWorkEmployeeConfig.newEmployeeSpecialDateConfig = {
            diff: this.newCustomer * (this.specialDay),
            duration: {
              num: Number(this.inductionDaysNumber),
              timeUnit: this.inductionDaysType
            },
            time: this.specialDateTime
          }
        }
        if (this.sendTimeType === 'PERIODIC') {
          taskInfo.weWorkEmployeeConfig.periodic.rule = this.periodicRule
          if (this.periodicRule === 'DAY') {
            taskInfo.weWorkEmployeeConfig.periodic.dayConfig = {
              time: this.checkTime
            }
          }
          if (this.periodicRule === 'WEEK') {
            taskInfo.weWorkEmployeeConfig.periodic.weekConfig = {
              days: this.setWeek,
              time: this.checkTime
            }
          }
          if (this.periodicRule === 'MOUTH') {
            taskInfo.weWorkEmployeeConfig.periodic.monthConfig = {
              day: this.setMonthTime,
              time: this.checkTime
            }
          }
          if (this.periodicRule === 'YEAR') {
            taskInfo.weWorkEmployeeConfig.periodic.yearConfig = {
              date: this.dataPicker,
              time: this.checkTime,
              type: this.GregorianOrLunar
            }
          }
        }

      }
      if (this.selectedGroupType === 'CUSTOMER_GROUP') {
        taskInfo.sendType = 'CUSTOMER_GROUP'
        taskInfo.weWorkCustomerGroupConfig = {
          sendTimeType: this.sendTimeType,
          timed: timed,
          periodic: {},
          groupIds: [],
          originAdminSelectedIds: [],
          groupAdminIds: [],
          groupAdminType: this.groupAdminType
        }
        if (this.groupAdminType !== 'ALL') {
          taskInfo.weWorkCustomerGroupConfig.groupAdminIds = this.groupAdminIds
          taskInfo.weWorkCustomerGroupConfig.originAdminSelectedIds = this.originAdminSelectedIds
        }
        if (this.sendTimeType === 'PERIODIC') {
          taskInfo.weWorkCustomerGroupConfig.periodic.rule = this.periodicRule
          if (this.periodicRule === 'DAY') {
            taskInfo.weWorkCustomerGroupConfig.periodic.dayConfig = {
              time: this.checkTime
            }
          }
          if (this.periodicRule === 'WEEK') {
            taskInfo.weWorkCustomerGroupConfig.periodic.weekConfig = {
              days: this.setWeek,
              time: this.checkTime
            }
          }
          if (this.periodicRule === 'MOUTH') {
            taskInfo.weWorkCustomerGroupConfig.periodic.monthConfig = {
              day: this.setMonthTime,
              time: this.checkTime
            }
          }
          if (this.periodicRule === 'YEAR') {
            taskInfo.weWorkCustomerGroupConfig.periodic.yearConfig = {
              date: this.dataPicker,
              time: this.checkTime,
              type: this.GregorianOrLunar
            }
          }
        }
      }
      if (this.selectedGroupType === 'CUSTOMER') {
        taskInfo.sendType = this.customerScopeName
        taskInfo.weWorkCustomerConfig = {
          sendTimeType: this.sendTimeType,
          timed: timed,
          periodic: {},
          employeeIds: [],
          tagIds: [],
          to: this.customerScopeName
        }
        tags = this.showTagsList.length > 0?this.showTagsList.map(item=>item.id):[]
        originSelectIds=this.userTags.length >0?this.userTags.map(item=>item.id):[]
        employeeIds = this.userTags.filter(item=>item.isMember===true).map(member=>member.id)
        taskInfo.weWorkCustomerConfig.tagIds = tags
        taskInfo.weWorkCustomerConfig.employeeIds = employeeIds
        taskInfo.weWorkCustomerConfig.originSelectIds =originSelectIds
        if (this.sendTimeType === 'PERIODIC') {
          taskInfo.weWorkCustomerConfig.periodic.rule = this.periodicRule
          if (this.periodicRule === 'DAY') {
            taskInfo.weWorkCustomerConfig.periodic.dayConfig = {
              time: this.checkTime
            }
          }
          if (this.periodicRule === 'WEEK') {
            taskInfo.weWorkCustomerConfig.periodic.weekConfig = {
              days: this.setWeek,
              time: this.checkTime
            }
          }
          if (this.periodicRule === 'MOUTH') {
            taskInfo.weWorkCustomerConfig.periodic.monthConfig = {
              day: this.setMonthTime,
              time: this.checkTime
            }
          }
          if (this.periodicRule === 'YEAR') {
            taskInfo.weWorkCustomerConfig.periodic.yearConfig = {
              date: this.dataPicker,
              time: this.checkTime,
              type: this.GregorianOrLunar
            }
          }
        }
      }
      console.log(taskInfo)
      if (this.taskName === '') {
        this.$message({
          message: '任务名称不能为空',
          duration: 2000,
          type: 'warning'
        })
        return
      }
      console.log('employeeSelectedConfigs', employeeSelectedConfigs)
      console.log('employeeIds', employeeIds)
      if (((this.selectedGroupType === 'CUSTOMER' && this.customerScopeName === 'CONDITIONAL') && (employeeIds.length === 0 && tags.length === 0))) {

        this.$message({
          message: '发送范围和标签请选择其一',
          duration: 2000,
          type: 'warning'
        })
        return;
      }
      if (((this.selectedGroupType === 'EMPLOYEE' && this.sendingRule !== 'NEW_EMPLOYEE')) && this.employeeConfigTag.length === 0) {
        this.$message({
          message: '请选择发送范围',
          duration: 2000,
          type: 'warning'
        })
        return;
      }
      if (this.selectedGroupType==='CUSTOMER_GROUP'&&this.groupAdminIds.length===0&&this.groupAdminType!=='ALL'){
        this.$message({
          message: '请选择发送范围',
          duration: 2000,
          type: 'warning'
        })
        return;
      }
      if (this.sendTimeType === 'TIMED') {
        let time = true
        if (this.checkDateTime === '') {
          this.$message({
            message: '请选择时间',
            duration: 2000,
            type: 'warning'
          })
          return time = false
        }
        if (!time) {
          return
        }
      }
      if (this.sendTimeType === 'PERIODIC') {
        let time = true
        if (this.periodicRule === 'WEEK') {
          if (this.setWeek.length === 0) {
            this.$message({
              message: '请选择重复时间',
              duration: 2000,
              type: 'warning'
            })
            return time = false
          }
        }
        if (this.periodicRule === 'YEAR') {
          if (this.dataPicker === '') {
            this.$message({
              message: '请选择日期',
              duration: 2000,
              type: 'warning'
            })
            return time = false
          }
        }
        if (this.checkTime === '') {
          this.$message({
            message: '请选择时间',
            duration: 2000,
            type: 'warning'
          })
          return time = false
        }
        if (!time) {
          return
        }
      }
      if (taskInfo.text.content === '' && taskInfo.attachments.length === 0) {
        this.$message({
          message: "请至少有一项发送内容",
          duration: 2000,
          type: "warning",
        });
        return
      }
      if (this.taskTitle === '新增群发任务') {
        let url = '/scrm-api/group-send-message-task'
        this.$http.post(url, taskInfo).then(res => {
          console.log(res)
          if (res.status === 200) {
            this.$message({
              message: '新增任务成功',
              duration: 2000,
              type: 'success'
            })
            this.getTask()
          }

        })
      } else {
        let url = '/scrm-api/group-send-message-task/' + this.taskId
        this.$http.put(url, taskInfo).then(res => {
          if (res.status === 200) {
            this.$message({
              message: '更新任务成功',
              duration: 2000,
              type: 'success'
            })
            this.getTask()
          }
        })
      }
      this.taskDrawer = false
      this.showTree = false

    },
    //删除任务
    deleteTask(id) {
      console.log(id)
      this.taskId = id

      this.$confirm('确定删除任务, 是否继续?', '删除任务', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let url = '/scrm-api/group-send-message-task/' + id
        this.$http.delete(url).then(res => {
          if (res.status === 200) {
            this.$message({
              message: '删除任务成功',
              duration: 2000,
              type: 'success'
            })
            this.getTask()
          }
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除',
          duration: 2000
        });
      });

    },
    //获取群发任务
    getTask() {
      let data = Object.assign({}, this.taskPage, {
        page: this.taskPage - 1
      })
      let url = '/scrm-api/group-send-message-task/page?page=' + data.page + '&size=' + this.taskPageSize
      this.$http.get(url).then(res => {
        console.log(res)
        if (res.status === 200) {
          this.tableData = res.data.content
          this.taskTotal = res.data.totalElements
        }
      })

    },
    checkTags() {
      this.cutomerTagDialogVisible = true
      this.$nextTick(() => {
        this.$refs.tagSelection.tags = this.showTagsList
        let ids = []
        for (let i = 0; i < this.showTagsList.length; i++) {
          ids.push(this.showTagsList[i].id)
        }
        this.$refs.tagSelection.$refs.tree.setCheckedKeys(ids)
      })
    },
    //选择标签
    selectTags() {
      this.$nextTick(() => {
        this.showTagsList = this.$refs.tagSelection.tags
        this.cutomerTagDialogVisible = false
      })
    },
    //取消选择标签
    cacelTags() {
      this.cutomerTagDialogVisible = false
      /*this.showTagsList=this.$refs.tagSelection.tags*/
    },
    loadTagsData() {
      this.$http.get("/scrm-api/client-tag/group").then((response) => {
        console.log('tags list:', response.data);
        this.tagsList = formatTree(response.data);
      });
    },
    handleTagClose(id) {
      console.log(id)
      this.$nextTick(() => {
        console.log(this.$refs.tagSelection)
        if (this.$refs.tagSelection !== undefined) {
          this.$refs.tagSelection.deleteTag(id)
          this.showTagsList = this.$refs.tagSelection.tags
        } else {
          this.$message.warning('请先打开选择标签再删除')
        }

      })
    },
    //获取员工
    getWeWorkList() {
      let url = '/scrm-api/we-work/member'
      this.$http.get(url).then(res => {
        console.log(res)
        if (res.status === 200) {
          this.memberList = res.data
          this.memberList.forEach(item => {
            this.$set(item, 'checked', false)
            this.setChecked(item.children)
          })
          this.getRoleTreeRootNode(this.memberList[0].id)
          console.log(this.memberList)
        }

      })
    },
    // 获取树形结构默认展开节点
    getRoleTreeRootNode(provincialCenterId) {
      this.treeExpandData.push(provincialCenterId)
      console.log(this.treeExpandData)
    },
    setChecked(value) {
      if (value !== null) {
        value.forEach(item => {
          this.$set(item, 'checked', false)
          this.setChecked(item.children)
        })
      } else
        return value
    },
    setActiveTreeIndex() {
      console.log('123')
      /*  this.showTree=!this.showTree*/
      this.memberDialogTableVisible = true
      this.openMember = 'member'
      let arr = [];
      this.userTags.forEach((item) => {
        arr.push(item.id);
      })
      console.log('arrarr', arr)
      setTimeout(() => {
        this.initShowOrTree(arr, true, "init");
       /* setTimeout(() => {
          showParent(this.userTags, 0)
        }, 100)*/
      }, 100);
    },
    setActiveGroupIndex() {
      this.memberDialogTableVisible = true
      this.openMember = 'QUN'
      let arr = [];
      this.originAdminSelected.forEach((item) => {
        arr.push(item.id);
      })
      setTimeout(() => {
        this.initShowOrTree(arr, true, "init");
        setTimeout(() => {
          showParent(this.originAdminSelected, 0)
        }, 100)
      }, 100);

    },
    selectOrg(data, checked, indeterminate) {
      /* let treeId = "tree" + this.activeTreeIndex;
       this.bindBots[this.activeTreeIndex].items = this.$refs[
           treeId
           ][0].getCheckedNodes();*/
      console.log("12345");
    },
    changeOrgChildrenProperties(list, fun) {
      if (list == null || list.length == 0 || fun == null) {
        return;
      }
      list.forEach(item => {
        if (item.isMember){
          this.childrenLength+=1
        }
        fun(item);
        this.changeOrgChildrenProperties(item.children, fun);
      });

    },
    changeCheckedOrg(node, data, type) {
      console.debug('select member changed', data);
      this.childrenLength = 0
      if (data.isMember){
        this.childrenLength=1
      }
      if (this.selectedGroupType==='EMPLOYEE'){
        this.changeOrgChildrenProperties(data.children, ()=>{});
        if (this.childrenLength===0){
          this.$message({
            message:'该组织架构下没有成员',
            duration:2000,
            type:'warning'
          })
          data.checked = false
          return
        }
        if (data.checked){
          this.userTags.push(data)
        }
        else {
          this.userTags.forEach((item,index)=>{
            if (this.userTags[index].id===data.id){
              this.userTags.splice(index,1)
            }
          })
        }
      }
      else {
        this.changeOrgChildrenProperties(data.children, (item) => item.checked = data.checked);
        if (this.childrenLength===0){
          this.$message({
            message:'该组织架构下没有成员',
            type:'warning',
            duration:2000
          })
        }
        console.log('childrenLength',this.childrenLength)
        if (type === 'member') {
          if (data.checked) {
            this.changeOrgChildrenProperties([data], (item) => this.userTags.unshift(item));
          } else {
            this.changeOrgChildrenProperties([data], (item) => {
              this.userTags.forEach((cell, cellIndex) => {
                if (cell.id == item.id) {
                  this.userTags.splice(cellIndex, 1);
                }
              });
            });
          }
          this.userTags = [...this.userTags];
          showParent(this.userTags, 0)
          console.log("userTags", this.userTags);
        } else {
          if (data.checked) {
            this.changeOrgChildrenProperties([data], (item) => this.originAdminSelected.unshift(item));
          } else {
            this.changeOrgChildrenProperties([data], (item) => {
              this.originAdminSelected.forEach((cell, cellIndex) => {
                if (cell.id == item.id) {
                  this.originAdminSelected.splice(cellIndex, 1);
                }
              });
            });

          }
          this.originAdminSelected = [...this.originAdminSelected];
          console.log("originAdminSelected", this.originAdminSelected);
          showParent(this.originAdminSelected, 0)

        }
      }
    },
    handleCloseOrganization(tagCellIndex, id) {
      this.initShowOrTree([id], false, "close");
      if (this.userTags.length > 0) {
        this.userTags.forEach((item, index) => {
          if (item.id === id) {
            this.userTags.splice(index, 1);
          }
        })
      }
      if (this.selectedGroupType==='EMPLOYEE'){
        this.employeeConfigTag=this.userTags
      }
      else {
        this.employeeConfigTag=this.userTags.filter(item=>item.isMember===true).map(value=>value)
      }
    },
    //群的选择员工
    handleCloseOrganizationGroup(tagCellIndex, id) {
      this.initShowOrTree([id], false, "close");
      if (this.originAdminSelected.length > 0) {
        this.originAdminSelected.forEach((item, index) => {
          if (item.id === id) {
            this.originAdminSelected.splice(index, 1);
          }
        })
      }

    },
    initShowOrTree(handleIdArr, isChecked, type) {
      const formOrgTree = (arr, handleIdArr, isChecked) => {
        if (type == "close") {
          arr.forEach((item) => {
            if (handleIdArr.indexOf(item.id) != -1) {
              item.checked = isChecked;
              if (item.children) {
                formOrgTree(item.children, handleIdArr, isChecked);
              }
            } else {
              if (item.children) {
                formOrgTree(item.children, handleIdArr, isChecked);
              }
            }
          });
        } else {
          arr.forEach((item) => {
            if (handleIdArr.indexOf(item.id) != -1) {
              item.checked = isChecked;
              if (item.children) {
                formOrgTree(item.children, handleIdArr, isChecked);
              }
            } else {
              item.checked = !isChecked;
              if (item.children) {
                formOrgTree(item.children, handleIdArr, isChecked);
              }
            }
          });
        }

        return arr;
      };
      this.memberList = [
        ...formOrgTree(this.memberList, handleIdArr, isChecked),
      ];
    },
    handleCheckedCitiesChange(value) {
      console.log(value);
    },
    /*切换发送人群，数据刷新*/
    changeSendPeople(value) {
      this.showTree = false;
      this.selectedGroupType = value;
      this.showTagsList = [];
      this.userTags = [];
      this.employeeConfigTag=[]
      this.originAdminSelected = []
      this.originAdminSelectedIds = []
      this.groupAdminIds = []
      this.welcomeConfig.attachments = []
      this.channelType = 'WE_WORK'
      this.sendingRule = 'GENERAL'
      this.welcomeConfig.text = {
        content: ''
      }
      console.log(value)
      this.customerScopeName = 'PUBLIC'
      this.groupIds = []
      this.setWeek = [2]
      this.checkTime = ''
      this.checkDateTime = ""
      this.sendTimeType = 'NOW'
      this.periodicRule = 'DAY'
      this.testUserIds = []
      this.groupBtnName = '按条件筛选客户群'
      if (this.taskTitle === "修改群发任务") {
        this.initDefault(value, this.selectTask);
      }
    },

    //切换入职类型时的规则
    specialDate(value) {
      console.log('切换规则', value)
    },

    handleSizeChange(value) {
      console.log(value);
      this.taskPageSize = value;
      this.getTask();
    },
    handleCurrentChange(value) {
      console.log(value);
      this.taskPage = value;
      this.getTask();
    },
    //改变发送记录的页数
    handleSizeChangeSend(value) {
      this.customerSendSize = value
      this.handleClick(this.lookSendDetail)
    },
    handleCurrentChangeSend(value) {
      this.customerSendPage = value
      this.handleClick(this.lookSendDetail)
    },
    //获取客户群
    getCustomerGroup() {
      let url =
          "/scrm-api/we-work/contact-group?limit=10" + "&cursor=" + this.cursor;
      this.$http.get(url).then((res) => {
        let groupList = [];
        if (res.status === 200) {
          groupList = res.data.group_chat_list;
          /* this.groupChatList=res.data.group_chat_list*/
          groupList.forEach((item) => {
            this.$set(item, "checked", false);
            this.groupChatList.push(item);
          });
          console.log(this.groupChatList);
          this.cursor = res.data.next_cursor;
        }
      });
    },
    lookMoreQun() {
      this.getCustomerGroup();
    },
    SelectCustomerQun() {

      if (this.originAdminSelectedTags.length===0&&this.groupAdminType==='DEPARTMENT'){
        this.$message({
          message:'请选择发送范围',
          type:'warning',
          duration:2000
        })
        return
      }
      this.SelectCustomerQunDialogVisible = false;

    },
    openSelectCustomerQun() {
      this.SelectCustomerQunDialogVisible = true;

    },
  },

  mounted() {
    this.getWeWorkList();
    this.getTask();
    this.loadTagsData();
  },
  watch: {
    userTags: {
      handler(tags, oldTags) {
        console.debug("user tags changed", tags);
        this.employeeConfigUserIds = [];
        this.employeeConfigTag=[]
        if (tags != null && tags.length > 0) {
          this.changeOrgChildrenProperties(tags, (item) => {
            if (item.isMember == true) {
              this.employeeConfigUserIds.push(item.id);
            }
          })
          this.employeeConfigUserIds = [...new Set(this.employeeConfigUserIds)]
          console.log(this.employeeConfigUserIds)
          if (this.selectedGroupType==='EMPLOYEE'){
            this.employeeConfigTag = [...this.reduceData(this.userTags)]
          }
          else {
            this.userTags.forEach(item => {
              if (item.isMember) {
                this.employeeConfigTag.push(item)
              }
            })
            this.employeeConfigTag = [...this.reduceData(this.employeeConfigTag)]
            console.log(this.employeeConfigTag)
          }
        }
      },
      deep: true
    },
    originAdminSelected: {
      handler(tags, oldTags) {
        console.debug("user tags changed", tags);
        this.originAdminSelectedTags = []
        if (tags != null && tags.length > 0) {
          tags.forEach(item => {
            if (item.isMember) {
              this.originAdminSelectedTags.push(item)
            }
          })
          this.originAdminSelectedTags = this.reduceData(this.originAdminSelectedTags)

        }
      },
      deep: true
    }
  },
  filters: {
    channel(value) {
      if (value === "WE_WORK") return "企业微信";
      if (value === "DING_TALK") return "钉钉";
    },
    crodType(value) {
      if (value === "EMPLOYEE")
        return "员工";
      if (value === "CUSTOMER") {
        return "客户";
      }
      if (value === "CUSTOMER_GROUP") {
        return "客户群";
      }

    },
    sendNumber(value) {
      if (value !== undefined) {
        if (value.crowd === "EMPLOYEE") {
          if (value.weWorkEmployeeConfig&&value.weWorkEmployeeConfig.userIds) {
            return value.weWorkEmployeeConfig.userIds.length;
          }
        }
        if (value.crowd === "CUSTOMER") {
          if (value.weWorkCustomerConfig&&value.weWorkCustomerConfig.employeeIds) {
            return value.weWorkCustomerConfig.employeeIds.length;
          }
        }
        if (value.crowd === "CUSTOMER_GROUP") {
          if (value.weWorkCustomerGroupConfig&&value.weWorkCustomerGroupConfig.groupAdminIds) {
            return value.weWorkCustomerGroupConfig.groupAdminIds.length;
          }
        }
      }
    },
  },
};
</script>

<style lang="less">
@import url("../../assets/less/fissionMarketing/massSend.less");

.custom-tree-node {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
  padding-right: 8px;
}

.tast-list-box {
  .drawer-container{
    .newCustomer{
      margin-top: 14px;
      .alert-text{
        background-color: #fdf6ec;
        color: #E6A23C;
        padding: 0px 16px;
        border-radius: 4px;
        display: flex;
        align-items: center;

      }
    }
  }
  .task-pagination {
    position: absolute;
    right: 40px;
    bottom: 20px;
  }
}

.bind-bot-self-tree-box {
  text-align: left;
  flex: auto;
  position: relative;
  line-height: 28px;
  height: 56px;
  padding: 0;

  .selected-box {
    border: solid 1px #e4e7ed;
    height: 56px;
    overflow-y: auto;
    display: flex;
    justify-content: space-between;

    .tag-box {
      height: 56px;
      flex: auto;

      .placeholder {
        height: 56px;
        line-height: 56px;
        color: #c0c4cc;
        margin-left: 8px;
      }

      .el-tag {
        margin-left: 6px;
      }
    }

    .handle-teg-box {
      flex: none;
      width: 15px;
      margin-left: 10px;
      line-height: 100%;
      cursor: pointer;
      position: absolute;
      right: 1px;
      top: 20px;

      span {
        height: 10px;
        flex: none;
      }
    }
  }

  .bind-bot-self-tree {
    padding-top: 5px;
    padding-left: 6px;
    z-index: 99999999999999999;
    position: relative;
    top: 3px;
    background-color: white;
    border-left: solid 1px #e4e7ed;
    border-right: solid 1px #e4e7ed;
    border-bottom: solid 1px #e4e7ed;
    border-radius: 6px;
    max-height: 400px;
    overflow: auto;
    min-height: 200px;

  }
}

.bind-bot-self-tree {
  max-height: calc(100vh - 400px);
  min-height: 500px;
  overflow-y: scroll;
  overflow-x: hidden;

  .el-tree-node__content > label.el-checkbox {
    position: absolute;
    right: 0;
  }
}

.screenQun {
  .dialog-title {
    margin-bottom: 10px;
    padding-top: 5px;
  }

  .memberShow {
    margin-top: 21px;
  }
}
  .selectMember{
    .el-dialog{
      margin-top: 5vh!important;
    }

  }
</style>
